export const DEFAULT_LOGO_PROPS = {
  src: `${import.meta.env.BASE_URL}agbaza-logo-180x180.png`,
  alt: "agbaza",
};
